export default interface PaymentModel {
  invoiceId: number;
  email?: string;
  cardholder: string;
  cardNumber: string;
  expiry: string;
  cvc: string;
  zip: string;
  state?: string;
  country?: string;
  amount: number;
  saveCard: boolean;
}

export const defaultPayment = {
  invoiceId: 0,
  email: '',
  cardholder: '',
  cardNumber: '',
  expiry: '',
  cvc: '',
  zip: '',
  state: 'PA',
  country: 'UNITED_STATES',
  amount: 0,
  saveCard: true,
};
